const Name = ({ text }) => {
  const base =
    'uppercase text-nameTeamCardMobile md:text-headingTeamCardDesktop text-olive font-chivoMono'

  return <span className={base}>{text}</span>
}

export default Name
